import Lookup from 'src/componentes/select2';
import PontoControleEdit from 'src/paginas/gestao-risco/ponto-controle/edit';

const PontoControle = ({ disabledNew, ...props }) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/PontoControleLookup"
      pageSize={99999}
      editComponent={disabledNew ? null : PontoControleEdit}
      {...props}
    />
  );
};

export default PontoControle;
